import { NotApplicableTypes } from '@constants/status';
import { isNaOrNr } from '@utils/universalTrackerValue';
import { UniversalTrackerValuePlain } from '@g17eco/types/universalTrackerValue';

export const MIXED_NA_NR_MESSAGE = 'Metric marked with mixed N/A (not applicable) and N/R (not reporting) statuses';
export const NA_MESSAGE = 'Metric marked N/A (not applicable to their org)';
export const NR_MESSAGE = 'Metric marked N/R (choosing not to report this metric)';

export const getNANRMessage = (utrvs: Pick<UniversalTrackerValuePlain, 'valueData'>[] | undefined): string | undefined => {
  if (!utrvs?.length) {
    return undefined;
  }

  if (!utrvs.every(u => isNaOrNr(u as UniversalTrackerValuePlain))) {
    return undefined;
  }

  const hasNA = utrvs.some(
    (u) => u?.valueData?.notApplicableType === NotApplicableTypes.na
  );

  const hasNR = utrvs.some(
    (u) => u?.valueData?.notApplicableType === NotApplicableTypes.nr
  );

  if (hasNA && hasNR) {
    return MIXED_NA_NR_MESSAGE;
  }

  return hasNA ? NA_MESSAGE : NR_MESSAGE;
};
